/**
 * Define incident levels for status notifications.
 * Assign an object using statuspage.io incident levels
 * and use this as an app-wide canonical measure of severity.
 */

  var values = { 
    none      : 0, 
    moderate  : 1, 
    severe    : 2 
  };
  // The names used as keys here come from Statuspage.io.
  // We assign values to them for our own purposes of scoring
  // and categorization. 
  var names = {
    'investigating' : values.severe, 
    'identified'    : values.moderate,
    'monitoring'    : values.none,
    'resolved'      : values.none 
  };
  export default {
    values : values,
    names : names
  };

